import { SystemStyleObject } from '@/styled-system/types';
import { Gleam } from '@zillow/constellation-10';

type UnreadIndicatorProps = {
  count?: number;
  dataTestId?: string;
  css?: SystemStyleObject;
};

export default function UnreadIndicator({ count = 0, dataTestId = '', css }: UnreadIndicatorProps) {
  return (
    <Gleam
      appearance="dot"
      count={count}
      dotProps={{
        label: 'New message(s)',
      }}
      tone="default"
      data-testid={dataTestId}
      css={css}
    />
  );
}
